import { DownloadOutlined } from "@ant-design/icons";
import { Alert, Button, Col, Form, Input, List, Row } from "antd";
import { buttonStyle, fullWidthStyle, titleStyle } from "../../constants/style";
import { SubmitStatus } from "../../api/work-order-api";
import ApiContext from "../../api/context";
import { useContext, useEffect, useState } from "react";
import Paragraph from "antd/es/typography/Paragraph";
import Title from "antd/es/typography/Title";
import { WorkOrder, WorkOrderResult } from "../../api/models";
import { toDateTimeString } from "../../constants";

type WorkOrderResultsProps = {
  workOrder?: WorkOrder,
  onClose: () => void
};

export default function (p: WorkOrderResultsProps) {
  const [results, setResults] = useState<WorkOrderResult[]>([]);
  const [loadStatus, setLoadStatus] = useState<SubmitStatus>(SubmitStatus.Submitting);
  const [error, setError] = useState<string>();
  const { api } = useContext(ApiContext);
  const isLoading = loadStatus === SubmitStatus.Submitting;

  useEffect(() => {
    api?.getWorkOrderResultList(p.workOrder?.workOrderID!).then(response => {
      if (response.status === 200 && response.body) {
        setResults(response.body);
        return;
      }

      switch (response.status) {
        case 204:
          setResults([]);
          break;
        default:
          setError("Failed to get the work order results.");
          break;
      }
    }).catch(() => {
      setError("Failed to get the work order results.");
    }).finally(() => {
      setLoadStatus(SubmitStatus.Idle);
    });
  }, []);

  return (
    <>
      <Title style={titleStyle} level={4}>{p.workOrder?.name}</Title>
      <Form
        layout="vertical"
        colon={false}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Work Order ID">
              <Paragraph strong>{p.workOrder?.workOrderID}</Paragraph>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Completion Time">
              <Paragraph strong>{toDateTimeString(p.workOrder?.status?.statusTime)}</Paragraph>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="Result Files">
          <List
            bordered={false}
            footer={false}
            loading={isLoading}
            pagination={{ pageSize: 5, hideOnSinglePage: results.length < 6 }}
            size="small"
            dataSource={results}
            locale={{ emptyText: isLoading ? "Loading..." : "There are no result files for this work order." }}
            renderItem={(item: WorkOrderResult) =>
              <List.Item key={item.name} style={{ padding: '5px 0' }}>
                <Row
                  justify="space-between"
                  align="middle"
                  style={fullWidthStyle}>
                  <span>{item.name}</span>
                  <Button
                    type="default"
                    icon={<DownloadOutlined />}
                    onClick={() => api?.downloadWorkOrderResult(p.workOrder?.workOrderID!, item.name)}
                  />
                </Row>
              </List.Item>
            }
          >
          </List>
        </Form.Item>
        <Row style={fullWidthStyle} justify="end" align="middle">
          <Button
            type="default"
            style={buttonStyle}
            onClick={p.onClose}>
            Close
          </Button>
        </Row>
        {
          !error ? undefined :
            <>
              <Paragraph></Paragraph>
              <Alert style={fullWidthStyle} type="error" title={error} />
            </>
        }
      </Form>
    </>);
}